<ng-container *ngIf="checkedServicesLength$ | async as quantity">
  <div class="select-service-footer" >
    <div class="container flex justify-between h-full items-center">
      <div>
        <span class="font-thin">{{ 'bookingPage.selectServicesPage.mobileFooter.selectedServicesCount' | translate:{ quantity } }}</span>
        <ng-content></ng-content>
      </div>
      <pub-proceed-button></pub-proceed-button>
    </div>
  </div>
</ng-container>
